import { UserRole as UserRoleEnum } from '@/constants';
import { User } from '@/types';

export type Currency = 'UAH' | 'USD' | 'MDL' | 'KZT' | 'UZS';

export type DefaultTableParams = {
    orderColumn: string;
    orderDirection: string;
    perPage: number;
    currentPage: number;
    search: string;
};

export const formatDate = (dateString: string): string => {
    return new Intl.DateTimeFormat('uk-UA', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(dateString));
};

export const formatPrice = (price: number, currency: Currency): string => {
    const currencyConfig: Record<Currency, { locale: string; code: string }> = {
        UAH: { locale: 'uk-UA', code: 'грн' },
        USD: { locale: 'en-US', code: 'USD' },
        MDL: { locale: 'ro-MD', code: 'лей' },
        KZT: { locale: 'kk-KZ', code: 'тг' },
        UZS: { locale: 'uz-UZ', code: 'сум' },
    };

    const config = currencyConfig[currency];
    const formattedNumber = new Intl.NumberFormat(config.locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(price);

    return `${formattedNumber} ${config.code}`;
};

export const getDefaultTableParams = (params: DefaultTableParams) => {
    return {
        order_column: params.orderColumn,
        order_direction: params.orderDirection,
        per_page: params.perPage,
        current_page: params.currentPage,
        search: params.search,
    };
};

export const canEditUser = (currentUser: User | null, targetUser: User | null): boolean => {
    if (!currentUser || !targetUser) {
        return false;
    }

    if (currentUser.role === UserRoleEnum.SuperAdmin) {
        return currentUser.id !== targetUser.id;
    }

    if (currentUser.role === UserRoleEnum.Admin) {
        return targetUser.role !== UserRoleEnum.SuperAdmin && targetUser.role !== UserRoleEnum.Admin;
    }

    return false;
};

export const canDeleteUser = (currentUser: User | null, targetUser: User | null): boolean => {
    if (!currentUser || !targetUser) {
        return false;
    }

    if (currentUser.role === UserRoleEnum.SuperAdmin) {
        return currentUser.id !== targetUser.id;
    }

    if (currentUser.role === UserRoleEnum.Admin) {
        return targetUser.role !== UserRoleEnum.SuperAdmin && targetUser.role !== UserRoleEnum.Admin;
    }

    return false;
};

export const stripHtml = (html: string | null | undefined): string => {
    if (!html) return '';
    const withBreaks = html
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<\/li>/gi, '\n')
        .replace(/<\/h[1-6]>/gi, '\n')
        .replace(/<\/div>/gi, '\n')
        .replace(/<\/tr>/gi, '\n')
        .replace(/<\/td>/gi, ' ');
    const tmp = document.createElement('div');
    tmp.innerHTML = withBreaks;
    const text = tmp.textContent || tmp.innerText || '';

    const formatted_text = text
        .replace(/[ \t]+/g, ' ')
        .replace(/\n{3,}/g, '\n\n')
        .trim();

    return formatted_text;
};
